module.exports = __webpack_public_path__ + "static/media/eye-icon.f999bb43.svg";